import { TDS_URL } from "../../CONSTANTS";
import { SYSTEM_ERROR } from "../../config/CONSTANTS";
import axios from "axios";
import Cookies from "universal-cookie";

const cook = new Cookies().get("loginData1");

const headersdata = {
  "content-type": "application/json",
  Accept: "application/json",
  Authorization: cook != undefined ? cook.accessToken : "",
};

export const getTdsKeyValuePair = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(TDS_URL() + "getKeyValueList", { headers: headersdata })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getTdsKeyValuePair axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTdsRecords = (data) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(TDS_URL() + "getAllRecords", data, { headers: headersdata })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getTdsRecords axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
export const addTDS = (data) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(TDS_URL(), data, { headers: headersdata })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in addTDS axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const editTDS = (id, data) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .put(TDS_URL() + id, data, { headers: headersdata })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in editTDS axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
